import { useEffect } from 'react';

/**
 * Hook para registrar e gerenciar Service Worker
 * Adiciona suporte para offline + cache ultra-rápido
 */
export function useServiceWorker() {
  useEffect(() => {
    // Skip durante SSR
    if (typeof window === 'undefined') {
      return;
    }

    // Apenas em produção ou com SW_ENABLED=true
    if (
      process.env.NODE_ENV !== 'production' &&
      process.env.REACT_APP_SW_ENABLED !== 'true'
    ) {
      console.log('[SW] Service Worker disabled in development');
      return;
    }

    if (!('serviceWorker' in navigator)) {
      console.warn('[SW] Service Workers not supported');
      return;
    }

    const registerServiceWorker = async () => {
      try {
        const registration = await navigator.serviceWorker.register(
          '/service-worker.js',
          {
            scope: '/',
          }
        );

        console.log('[SW] Registered successfully:', registration);

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;

          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (
                newWorker.state === 'installed' &&
                navigator.serviceWorker.controller
              ) {
                console.log('[SW] New version available. Reload to update.');
                broadcastNewVersionAvailable();
              }
            });
          }
        });
      } catch (error) {
        console.error('[SW] Registration failed:', error);
      }
    };

    registerServiceWorker();

    return () => {
      // Não desregistrar na unmount, deixar o SW funcionar em background
    };
  }, []);
}

/**
 * Broadcast para notificar sobre nova versão disponível
 * Dispara evento custom que componentes podem ouvir
 */
function broadcastNewVersionAvailable() {
  // Skip durante SSR
  if (typeof window === 'undefined') {
    return;
  }

  const event = new CustomEvent('sw:new-version', {
    detail: {
      message: 'Uma nova versão está disponível. Recarregue para atualizar.',
    },
  });

  window.dispatchEvent(event);
  console.log('[SW] New version available - please reload to update');
}
